/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseDashyKpiRecapTemplateConfig } from '../models/api-response-dashy-kpi-recap-template-config';
import { getDashyKpiRecapTemplateConfig } from '../fn/dashy-kpi-recap-template-config-api/get-dashy-kpi-recap-template-config';
import { GetDashyKpiRecapTemplateConfig$Params } from '../fn/dashy-kpi-recap-template-config-api/get-dashy-kpi-recap-template-config';
import { updateDashyKpiRecapTemplateConfig } from '../fn/dashy-kpi-recap-template-config-api/update-dashy-kpi-recap-template-config';
import { UpdateDashyKpiRecapTemplateConfig$Params } from '../fn/dashy-kpi-recap-template-config-api/update-dashy-kpi-recap-template-config';

@Injectable({ providedIn: 'root' })
export class DashyKpiRecapTemplateConfigApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDashyKpiRecapTemplateConfig()` */
  static readonly GetDashyKpiRecapTemplateConfigPath = '/v1/api/admin-ui/dashy-kpi-recap-template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDashyKpiRecapTemplateConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashyKpiRecapTemplateConfig$Response(params: GetDashyKpiRecapTemplateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>> {
    return getDashyKpiRecapTemplateConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDashyKpiRecapTemplateConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashyKpiRecapTemplateConfig(params: GetDashyKpiRecapTemplateConfig$Params, context?: HttpContext): Observable<ApiResponseDashyKpiRecapTemplateConfig> {
    return this.getDashyKpiRecapTemplateConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>): ApiResponseDashyKpiRecapTemplateConfig => r.body)
    );
  }

  /** Path part for operation `updateDashyKpiRecapTemplateConfig()` */
  static readonly UpdateDashyKpiRecapTemplateConfigPath = '/v1/api/admin-ui/dashy-kpi-recap-template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDashyKpiRecapTemplateConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDashyKpiRecapTemplateConfig$Response(params: UpdateDashyKpiRecapTemplateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>> {
    return updateDashyKpiRecapTemplateConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDashyKpiRecapTemplateConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDashyKpiRecapTemplateConfig(params: UpdateDashyKpiRecapTemplateConfig$Params, context?: HttpContext): Observable<ApiResponseDashyKpiRecapTemplateConfig> {
    return this.updateDashyKpiRecapTemplateConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>): ApiResponseDashyKpiRecapTemplateConfig => r.body)
    );
  }

}
